<template>
  <div>
    <h3 class="f14 divider txt-l mb10">
      <span class="pl0">{{industry.name}}</span>
    </h3>
    <p class="clearfix">
      <span v-for="position in industry.positions" :key="position.id" @click.prevent.stop="selectPosition(position)">{{position.name}}</span>
    </p>
  </div>
</template>
<script>
export default {
  name: 'position-item',
  components: {},
  data() {
    return {};
  },
  props: {
    industry: {
      type: Object,
      default() {
        return {};
      }
    },
    selectPositionIdList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    selectPosition(position) {
      this.$emit('select-position', position);
    }
  }
};
</script>

<style lang="less" scoped>
</style>
